import { getField, updateField } from 'vuex-map-fields'

// eslint-disable-next-line camelcase
export const state = () => ({
  searchBarText: undefined,
  protocol: undefined,
  user_name: undefined,
  cpf: undefined,
  group_name: undefined,
  operator_name: undefined,
  operator_login: undefined,
  channelFilter: undefined,
  authenticated_type: undefined,
  user: undefined,
  dateIntervalFilter: {
    timestamp1: undefined,
    timestamp2: undefined
  }
})

export const getters = {
  getField
}

export const actions = {
}

export const mutations = {
  updateField
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
